import React from 'react';
import type { PropsWithChildren } from 'react';

import type { DeadlyDigitsProductsType } from './themes/deadlydigits';
import type { ReckonProductsType } from './themes/reckon';
import { defaultReckonTheme } from './themes/reckon';
import { ThemeDecorator } from './themes/ThemeDecorator';
import { Themes } from './themes/themes';
import type { Tenancy } from './themes/types';

type LayoutProps = PropsWithChildren<{
  theme: Tenancy;
  product?: ReckonProductsType | DeadlyDigitsProductsType;
  hideFooter?: boolean;
  showPrivacyAndTermsAndCondition?: boolean;
}>;

export const Layout = ({
  children,
  theme,
  product,
  hideFooter,
  showPrivacyAndTermsAndCondition,
}: LayoutProps) => {
  const selectedTheme =
    Themes.find((t) => {
      return t.tenant === theme && t.product === product;
    }) ||
    Themes.find((t) => {
      return t.tenant === theme && t.product === 'default';
    }) ||
    defaultReckonTheme;

  return (
    <ThemeDecorator
      backgroundColor={selectedTheme.baseTheme.backgroundColor}
      footerDescription={selectedTheme.productTheme.footerDescription}
      footerLogo={selectedTheme.productTheme.footerLogo}
      headerLogo={selectedTheme.productTheme.headerLogo}
      hideFooter={hideFooter}
      leftBackgroundImage={selectedTheme.productTheme.leftBackgroundImage}
      publicFolder={selectedTheme.publicSubFolder}
      rightBackgroundImage={selectedTheme.productTheme.rightBackgroundImage}
      showPrivacyAndTermsAndCondition={showPrivacyAndTermsAndCondition}
      textColor={selectedTheme.baseTheme.textColor}
      textLinkColor={selectedTheme.baseTheme.textLinkColor}
      title={selectedTheme.title}
    >
      {children}
    </ThemeDecorator>
  );
};
